import { useMemo, useState } from 'react';
import { BordCheckBox, BordPhoto } from 'bord-design-system';
import { BordOneToneIcon } from 'components/NudosComponents';
import { IToolsBulkSelectionItem } from 'types/products';
import { bordColorTheme } from 'styles/styles.constants';
import { IToolsBulkSelectedRow, mapToolsBulkSelectedRows } from '../../productsModuleListing.utils';
import './ToolsBulkSelectedToolsCollapse.scss';

interface IToolsBulkSelectedToolsCollapseProps {
  tools: IToolsBulkSelectionItem[];
  onUnselectTool: (toolId: number) => void;
  width: string;
}

const ToolsBulkSelectedToolsCollapse = ({ tools, onUnselectTool, width }: IToolsBulkSelectedToolsCollapseProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const selectedToolRows = useMemo<IToolsBulkSelectedRow[]>(() => {
    return mapToolsBulkSelectedRows(tools);
  }, [tools]);

  const toggleExpanded = () => {
    setIsExpanded(prev => !prev);
  };

  const handleUnselectRow = (id: number) => {
    onUnselectTool(id);
  };

  const selectedToolsCount = selectedToolRows.length;

  return (
    <div className="toolsBulkSelectedToolsCollapse" style={{ width }}>
      <button
        type="button"
        className="toolsBulkSelectedToolsCollapseHeader"
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
      >
        <span className="toolsBulkSelectedToolsCollapseHeaderLeft">
          <span className="toolsBulkSelectedToolsCollapseTitle">Herramientas seleccionadas</span>
          <span className="toolsBulkSelectedToolsCollapseCountBadge" aria-hidden>
            {selectedToolsCount}
          </span>
        </span>

        <span className="toolsBulkSelectedToolsCollapseToggle">
          <span className="toolsBulkSelectedToolsCollapseToggleLabel">Detalle</span>
          <BordOneToneIcon
            variant={isExpanded ? 'arrowHeadUp' : 'arrowHeadDown'}
            standardSize={12}
            stroke={bordColorTheme.navyBlue[900]}
          />
        </span>
      </button>

      {isExpanded ? (
        <div className="toolsBulkSelectedToolsCollapsePhotoContainer">
          <div className="toolsBulkSelectedToolsDivider" />

          <div className="toolsBulkSelectedToolsCollapseList" role="list">
            {selectedToolRows.map(row => {
              const photoUrl = row?.photoUrl;
              const { displayName, displaySerial, statusLabel } = row;

              return (
                <div key={row.id} className="toolsBulkSelectedToolsCollapseItem" role="listitem">
                  <BordCheckBox isButtonActive handleClickButton={() => handleUnselectRow(row.id)} />

                  <BordPhoto url={photoUrl} variant="square" size="s32" imageProps={{ alt: displayName }} />

                  <div className="toolsBulkSelectedToolsCollapseItemBody">
                    <p className="toolsBulkSelectedToolsCollapseItemName">{displayName}</p>

                    <div className="toolsBulkSelectedToolsCollapseItemSerial">
                      <BordOneToneIcon variant="barCode2" standardSize={12} stroke={bordColorTheme.navyBlue[900]} />
                      <span className="toolsBulkSelectedToolsCollapseItemSerialText">{displaySerial}</span>
                    </div>
                  </div>
                  <span className="toolsBulkSelectedToolsCollapseItemBadge">{`Estado: ${statusLabel}`}</span>
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ToolsBulkSelectedToolsCollapse;
